import { z } from "zod";

import { eventTypeAppCardZod } from "@calcom/app-store/eventTypeAppCardZod";

const paymentOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const paymentOptionsSchema = z.array(paymentOptionSchema);

// Pledg gère lui-même l'échéancier (installment/deferred) une fois le client redirigé sur son
// checkout hébergé — cal.com ne voit qu'un paiement payé ou non, donc uniquement ON_BOOKING.
// Pas de valeur "HOLD" : voir decisions.md ADR-004 et PAYMENT_APP_GUIDE.md:32-39.
export const PledgPaymentOptions = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING",
  },
];

type PaymentOption = (typeof PledgPaymentOptions)[number]["value"];
const VALUES: [PaymentOption, ...PaymentOption[]] = [
  PledgPaymentOptions[0].value,
  ...PledgPaymentOptions.slice(1).map((option) => option.value),
];
export const paymentOptionEnum = z.enum(VALUES);

export const appDataSchema = eventTypeAppCardZod.merge(
  z.object({
    price: z.number(),
    currency: z.string(),
    paymentOption: z.string().optional(),
    enabled: z.boolean().optional(),
  })
);
export const appKeysSchema = z.object({});
